module.exports = __webpack_public_path__ + "img/doctor.ac890ff4.png";